
import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import appconst from "@/lib/appconst";
import * as imageConversion from "image-conversion";

@Component
export default class FileUploader extends Vue {
    private faceUploadAction =appconst.remoteServiceBaseUrl + 'sysadmin/UploadFile/ProductUpload'
    private previewImageUrl = null;
    private faceUploading = false;

    @Prop({ default: null })
    readonly url: string;

    @Prop({ default: "上传图片或视频" })
    readonly uploadText: string;

    @Prop({ default: "重新上传" })
    readonly reuploadText: string;

    @Prop({ default: null })
    readonly accept: string;

    @Prop({ default: "" })
    readonly tips: string;

    @Prop({ default: null })
    readonly customClass: string;

    @Prop({ default: false })
    readonly asidePreview: boolean;

    @Watch("url")
    private onUrlChange(val) {
        this.previewImageUrl = val;
    }

    private mounted() {
        this.previewImageUrl = this.url;
    }
    obj: any = [];
    private onFaceUpladSuccess(response, file, fileList) {
       
        this.faceUploading = false;
        this.previewImageUrl = response.result.url;
        this.obj = {
            name: file.name,
            size: file.size,
            url: response.result.url,
            type: file.raw.type,
        };
        this.onSuccess(this.obj);
    }

    private onFaceUploadError(error) {
        this.faceUploading = false;
        this.previewImageUrl = this.url;
        this.$message.error("上传失败");
    }

    @Emit("success")
    private onSuccess(fileInfo: any) {}
}
